export const SOCIAL_MEDIA_FEATURE_KEY = 'social-media';
